import { apiServiceV2 } from "@src/api/index";
import { AxiosResponse } from "axios";

export const sendSlackError = async (data: {
	message: string;
	title?: string;
	channel?: string;
}): Promise<{ isSuccess: boolean }> => {
	const response: AxiosResponse<{ isSuccess: boolean }> = await apiServiceV2.post(
		"/slack/error",
		{
			message: data.message,
			title: data.title,
			channel: data.channel,
		},
	);
	return response.data;
};
